import { Heading } from '@/src/tailwindui/heading';
import {
    Table,
    TableHeader,
    TableRow,
    TableHead,
    TableCell,
    TableBody,
} from '@/src/tailwindui/table';
import useDeviceStats from './hooks/useEventDeviceStats';
import SmallLoader from '@/src/Common/components/SmallLoader';
import moment from 'moment-timezone';
import { TabletIcon } from 'lucide-react';
export default function DeviceStats({
    activationId,
}: {
    activationId: number;
}) {
    const { queueData, printRollup, printsByDevice, isLoading, error } =
        useDeviceStats(activationId);

    if (error) {
        return (
            <div className="p-6 text-red-500">Failed to load queue data</div>
        );
    }

    if (isLoading || !queueData) {
        return <SmallLoader />;
    }

    if (!queueData.length) {
        return (
            <div className="mx-auto max-w-4xl w-full h-full overflow">
                <div className="flex flex-col gap-2 w-full h-full items-center justify-center">
                    <p className="text-sm text-center text-gray-500 h-full flex items-center justify-center flex-col gap-6">
                        <TabletIcon className="h-10 w-10 text-gray-400 dark:text-gray-600" />
                        <p className="text-gray-400 dark:text-gray-600">
                            No devices have uploaded photos to this event.
                        </p>
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="mx-auto max-w-4xl w-full overflow">
            <div className="flex flex-wrap items-end justify-between gap-4 transition-all duration-300 px-4 ">
                <div className="flex flex-row justify-between w-full">
                    <div className="flex flex-col gap-2 pt-4 w-full">
                        <Heading className="text-5xl">Devices</Heading>
                        <p className="text-sm text-gray-500">
                            Below is a list of all devices which have uploaded
                            photos to this event.
                        </p>
                        <p className="text-sm text-gray-500">
                            Total prints this event:{' '}
                            <span className="font-semibold text-gray-900 dark:text-gray-100">
                                {printRollup.total}
                            </span>
                        </p>
                        <div className="w-full overflow-auto">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableHeader className="monospace-font">
                                            Device Name
                                        </TableHeader>
                                        <TableHeader className="monospace-font">
                                            Uploaded
                                        </TableHeader>
                                        <TableHeader className="monospace-font">
                                            Remaining
                                        </TableHeader>
                                        <TableHeader className="monospace-font">
                                            Prints
                                        </TableHeader>
                                        <TableHeader className="monospace-font">
                                            Last Seen
                                        </TableHeader>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {queueData.map((item) => (
                                        <TableRow>
                                            <TableCell>{item?.name}</TableCell>
                                            <TableCell>
                                                {/* @ts-ignore */}
                                                {item.queueData?.uploaded}
                                            </TableCell>
                                            <TableCell>
                                                {/* @ts-ignore */}
                                                {item.queueData?.unuploaded}
                                            </TableCell>
                                            <TableCell>
                                                {printsByDevice.get(
                                                    item.deviceKeyId,
                                                ) ?? '-'}
                                            </TableCell>
                                            <TableCell>
                                                {moment(item.updatedAt).toNow(
                                                    true,
                                                )}{' '}
                                                ago
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="my-10 mt-6" />
        </div>
    );
}
